

export class DailyTravellingAllowanceDto implements IDailyTravellingAllowanceDto {
    id!: number;
    fromDate!: Date;
    toDate!: Date;
    fromKM!: number;
    toKM!: number;
    allowance!: number;
    isActive!: boolean;

    constructor(data?: IDailyTravellingAllowanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.fromKM = _data["fromKM"];
            this.toKM = _data["toKM"];
            this.allowance = _data["allowance"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): DailyTravellingAllowanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new DailyTravellingAllowanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["fromKM"] = this.fromKM;
        data["toKM"] = this.toKM;
        data["allowance"] = this.allowance;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IDailyTravellingAllowanceDto {
    id: number;
    fromDate: Date;
    toDate: Date;
    fromKM: number;
    toKM: number;
    allowance: number;
    isActive: boolean;
}

